






























































































































































































































































































































































import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import * as R from 'ramda';
import { v4 as uuidv4 } from 'uuid';
import InfiniteLoading from 'vue-infinite-loading';
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  EventTriggerType,
  JobExecutionStatus,
  _Boolean,
  TaskExecutionStatus,
} from '@/API';
import { TaskHistory } from '@/appsync/graphql/taskHistory';
import {
  getPreSignedUrlForDownloadingIFXAPFile,
  downloadFromPreSignedUrl,
} from '@/appsync/lambda/downloadFileViaConversionApiService';
import {
  fetchScheduledEventHistoriesBasedOnBetweenDates,
  fetchScheduledEventMetadatas,
  fetchScheduledHolidayMetadatas,
  fetchPublicHolidays,
} from '@/appsync/service/EventCalendarQueryService';
import { fetchJobs } from '@/appsync/service/JobQueryService';
import { toLocaleDatetimeString } from '@/containers/globals/Util';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import EventViewTabSelector from '@/containers/templates/EventViewTabSelector.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import {
  UserInfo,
  LoginInfo,
  JobIdAndTitle,
  ScheduledHolidayMetadataForFront,
  PublicHolidayForFront,
  ScheduledEventMetadataWithDetailForFront,
  EventSearchInput,
  CalendarEvent,
  ScheduledEventHistoryForFront,
  EventForDownload,
} from '@/types/type';
import {
  getDisabledRoutes,
  isAccessedFromIosDeviceOrSafariBrowser,
  getEndDayOfThisMonth,
  getFirstDayOfThisMonth,
} from '@/utils/CommonUtils';
import {
  taskIconColor,
  taskIcon,
  eventIcon,
  eventIconColor,
  occurrencesForTargetMonth,
  EventType,
  makeAdjustments,
  FAILED_TO_ADJUST_DATE_EVENT_ID_KEY,
  filterDuplicatedEvents,
  getSpecifiedPeriodItems,
} from '@/utils/EventCalendarUtils';
import { newPortalDate, PortalDate } from '@/utils/PortalDate';
import {
  JST_OFFSET_MINS,
  Language,
  PAGE_PATH_BY_NAME,
  ICON,
} from '@/utils/consts';

enum Option {
  Holiday = 'Holiday',
  Event = 'Event',
}

@Component({
  components: {
    PortalAppBar,
    EventViewTabSelector,
    PageNotFound,
    ErrorMessagePageTemplate,
    InfiniteLoading,
  },
})
export default class EventList extends Vue {
  private loading: boolean = true;
  private isJobSchedulerEnabled: boolean = false;
  private loginInfo!: LoginInfo;
  private hasSchedulerPermission: boolean = false;

  private notEnabledImgAltMessage: String = 'Page Not Enabled';
  private notEnabledImgName: String = 'page-not-enabled';
  private notEnabledImgWidth: String = '250px';
  private notEnabledImgHeight: String = '186px';

  private isAccessingFromJST: boolean = false;
  private showAccessFromIosOrSafariWarningDialog: boolean = false;
  private downloading: boolean[] = [];
  private isVisible: boolean = true;
  private lastScrollPosition: number = 0;
  private startDateMenu: boolean = false;
  private endDateMenu: boolean = false;

  private itemsPerLoad: number = 30;
  private infiniteId: number = +new Date();

  private events: CalendarEvent[] = [];
  private visibleEvents: CalendarEvent[] = [];
  private scheduledEventHistoriesBasedOnBetweenDates!: ScheduledEventHistoryForFront[];
  private publicHolidays!: PublicHolidayForFront[];
  private allHolidayEvents: CalendarEvent[] = [];
  private moreThan1000ConsecutiveHolidayContainingEvents: any[] = [];
  private scheduledHolidayMetadatas: ScheduledHolidayMetadataForFront[] = [];
  private scheduledEventMetadatas: ScheduledEventMetadataWithDetailForFront[] = [];

  private expandedCard: number | null = null;
  private jobIdAndTitles: JobIdAndTitle[] = [];

  private searchInput: EventSearchInput = {
    eventTitle: '',
    startDate: this.firstDayOfMonth,
    endDate: this.lastDayOfMonth,
    startTime: '00:00',
    endTime: '23:59',
    jobExecutionStatus: null,
    eventTriggerType: null,
    executedBy: '',
    job: null,
  };

  public async created(): Promise<void> {
    this.loginInfo = commonModule.loginInfo;
    await refreshStores(this.loginInfo);
    this.hasSchedulerPermission = (this as any).$hasPermission(
      'menus.scheduler'
    );
    const disabledRoutes = await getDisabledRoutes(
      this.loginInfo.tenant,
      this.loginInfo.landscape,
      this.loginInfo.loginName
    );

    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.eventList)) {
      this.isJobSchedulerEnabled = true;

      const isAccessedFromNotRecommendedEnv: boolean = isAccessedFromIosDeviceOrSafariBrowser();
      if (isAccessedFromNotRecommendedEnv) {
        this.showAccessFromIosOrSafariWarningDialog = true;
      }

      this.isAccessingFromJST =
        new Date().getTimezoneOffset() === JST_OFFSET_MINS;

      await this.setInitialValueForJobScheduler();
      const thisMonth = newPortalDate(dayjs(), 'YYYY-MM-DD');
      await this.fetchEvents(
        getFirstDayOfThisMonth(thisMonth),
        getEndDayOfThisMonth(thisMonth)
      );
      const jobs = await fetchJobs(
        this.loginInfo.tenant,
        this.loginInfo.landscape
      );
      this.jobIdAndTitles = R.map(R.pick(['title', 'id']))(jobs);
    }
    this.loading = false;
  }

  private mounted() {
    window.addEventListener('scroll', this.onScroll);
  }

  private beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }

  private onScroll() {
    const currentScrollPosition = window.scrollY;
    this.isVisible = currentScrollPosition < this.lastScrollPosition;
    this.lastScrollPosition = currentScrollPosition;
  }

  private clear() {
    this.searchInput.eventTitle = '';
    this.searchInput.startDate = this.firstDayOfMonth;
    this.searchInput.endDate = this.lastDayOfMonth;
    this.searchInput.startTime = '00:00';
    this.searchInput.endTime = '23:59';
    this.searchInput.jobExecutionStatus = null;
    this.searchInput.eventTriggerType = null;
    this.searchInput.executedBy = '';
    this.searchInput.job = null;
  }

  private async search() {
    this.events = [];
    const startDateTimeFromInputWithSec = this.startDateTimeFromInput;
    const endDateTimeFromInputWithSec = this.endDateTimeFromInput;
    await this.fetchEvents(
      startDateTimeFromInputWithSec,
      endDateTimeFromInputWithSec
    );
    this.events = await this.filteredBySearch(this.searchInput, this.events);
    this.loadInitialVisibleEvents();
  }

  private redirectTo(item: Option) {
    const newId = uuidv4();
    switch (item) {
      case Option.Holiday:
        return router.push({
          name: 'createHoliday',
          params: { id: newId },
        });
      case Option.Event:
        return router.push({
          name: 'createEvent',
          params: { id: newId },
        });
      default: {
        const inspector: never = item;
        return router.push(PAGE_PATH_BY_NAME.eventCalendar);
      }
    }
  }

  private async setInitialValueForJobScheduler(): Promise<void> {
    this.isJobSchedulerEnabled = true;
    this.scheduledHolidayMetadatas = await fetchScheduledHolidayMetadatas(
      this.loginInfo.tenant,
      this.loginInfo.landscape
    );
    this.scheduledEventMetadatas = await fetchScheduledEventMetadatas(
      this.loginInfo.tenant,
      this.loginInfo.landscape
    );
    this.publicHolidays = await fetchPublicHolidays(i18n.locale);
  }

  private downloadCsv(): void {
    const downloadJson = this.transformEventForDownload(this.events);
    const csv = Papa.unparse(downloadJson);
    const blob = new Blob([csv], { type: 'text/csv' });
    const fileName = `searchResult_${dayjs().format('YYYYMMDDHHmmss')}.csv`;
    saveAs(blob, fileName);
  }

  private transformEventForDownload(
    events: CalendarEvent[]
  ): EventForDownload[] {
    return R.chain(event => {
      const jobDurationInSec =
        dayjs(event.updatedAt).diff(dayjs(event.start)) / 1000;

      const jobData = {
        eventTriggerType: event.eventTriggerType,
        eventId: event.eventId,
        eventTitle: event.title,
        jobId: event.jobId,
        jobTitle: event.jobTitle,
        category: 'Job',
        taskTitle: '-',
        taskOrder: '-',
        executionStatus: event.status,
        executionStartTime: event.start
          ? toLocaleDatetimeString(event.start.toString())
          : '-',
        executionEndTime: this.isNotTriggered(event.status)
          ? '-'
          : event.updatedAt && this.isNotRunning(event.status)
          ? toLocaleDatetimeString(event.updatedAt.toString())
          : '-',
        durationInSec: R.includes(event.status, [
          JobExecutionStatus.Succeeded,
          JobExecutionStatus.Failed,
        ])
          ? jobDurationInSec
          : '-',
      };

      const taskData = event.taskHistories
        ? event.taskHistories.map(taskHistory => {
            const taskDurationInSec =
              taskHistory.taskStartDateTime && taskHistory.taskEndDateTime
                ? dayjs(taskHistory.taskEndDateTime).diff(
                    dayjs(taskHistory.taskStartDateTime),
                    'second'
                  )
                : null;

            return {
              ...jobData,
              category: 'Task',
              taskTitle: taskHistory.taskTitle
                ? taskHistory.taskTitle
                : taskHistory.task.title,
              taskOrder: taskHistory.order,
              executionStatus:
                taskHistory.taskExecutionStatus === TaskExecutionStatus.Skipped
                  ? JobExecutionStatus.NotTriggered
                  : taskHistory.taskExecutionStatus,
              executionStartTime: taskHistory.taskStartDateTime
                ? dayjs(taskHistory.taskStartDateTime).format(
                    'YYYY/MM/DD HH:mm:ss'
                  )
                : '-',
              executionEndTime: taskHistory.taskEndDateTime
                ? dayjs(taskHistory.taskEndDateTime).format(
                    'YYYY/MM/DD HH:mm:ss'
                  )
                : '-',
              durationInSec: R.includes(taskHistory.taskExecutionStatus, [
                TaskExecutionStatus.Succeeded,
                TaskExecutionStatus.Failed,
              ])
                ? taskDurationInSec
                : '-',
            };
          })
        : [];

      return [jobData, ...taskData];
    }, events);
  }

  private getShowMoreText(taskHistories: TaskHistory[]): string {
    return `${this.$t('jobScheduler.eventCalendar.showMore1')}
      ${taskHistories.length}
      ${this.$t('jobScheduler.eventCalendar.showMore2')}`;
  }

  private isDownloadEnabled(event: CalendarEvent): boolean | undefined {
    return (
      event.hasOutputFile &&
      this.hasIncludeInDownloadTrue(event) &&
      R.includes(event.status, [
        JobExecutionStatus.Succeeded,
        JobExecutionStatus.Failed,
      ])
    );
  }

  private async downloadOutput(event: CalendarEvent, index: any) {
    if (event.eventHistoryId) {
      this.$set(this.downloading, index, true);
      const signedUploadUrl = await getPreSignedUrlForDownloadingIFXAPFile(
        event.eventHistoryId
      );
      await downloadFromPreSignedUrl(signedUploadUrl);
      this.$set(this.downloading, index, false);
    }
  }

  private async fetchEvents(
    startDate: PortalDate,
    endDate: PortalDate
  ): Promise<void> {
    this.scheduledEventHistoriesBasedOnBetweenDates = await fetchScheduledEventHistoriesBasedOnBetweenDates(
      this.loginInfo.tenant,
      this.loginInfo.landscape,
      startDate,
      endDate
    );
    this.getPublicHolidayEvents();
    this.getCustomHolidayEvents(endDate.toString());
    this.getNormalEvents(startDate, endDate);
  }

  private shouldShowMoreButton(event: CalendarEvent) {
    return event.taskHistories && event.taskHistories.length > 5;
  }

  private getTaskTitle(taskHistory: TaskHistory): string {
    // taskHistoryテーブルにtaskTitleカラム追加前のデータ対応
    // 古いデータではtaskHistory.taskTitleがnullの場合があるため、task.titleを代わりに使用する
    return taskHistory && taskHistory.taskTitle
      ? taskHistory.taskTitle
      : taskHistory.task.title;
  }

  private getTaskStartEndTimeText(taskHistory: TaskHistory): string {
    const start = taskHistory.taskStartDateTime
      ? dayjs(taskHistory.taskStartDateTime).format('HH:mm:ss')
      : '';
    const end = taskHistory.taskEndDateTime
      ? dayjs(taskHistory.taskEndDateTime).format('HH:mm:ss')
      : '';
    if (start || end) {
      return `${start} - ${end}`;
    }
    return '';
  }

  private hasIncludeInDownloadTrue(event: CalendarEvent): boolean {
    return R.pipe(
      R.pathOr([], ['taskHistories']),
      R.any(R.propEq('includeInDownload', _Boolean._true))
    )(event);
  }

  private jobPath(jobId: string): object {
    return { name: 'job', params: { id: jobId } };
  }

  private isNotRunning(status: JobExecutionStatus | undefined): boolean {
    return status !== JobExecutionStatus.Running;
  }

  private isNotTriggered(status: JobExecutionStatus | undefined): boolean {
    return status == JobExecutionStatus.NotTriggered;
  }

  private formattedEventEnd(event: CalendarEvent): string {
    if (this.isNotTriggered(event.status)) {
      return '-';
    }
    return event.updatedAt && this.isNotRunning(event.status)
      ? toLocaleDatetimeString(event.updatedAt)
      : '-';
  }

  private formattedEventStart(start: string): string {
    return toLocaleDatetimeString(start);
  }

  private getTaskIconColor(taskHistory: TaskHistory) {
    return taskIconColor(taskHistory);
  }

  private getTaskIcon(taskHistory: TaskHistory) {
    return taskIcon(taskHistory);
  }

  private loadInitialVisibleEvents() {
    this.visibleEvents = [];
    const initialLoad = this.events.slice(0, this.itemsPerLoad);
    this.visibleEvents.push(...initialLoad);
    this.infiniteId += 1;
  }

  private toggleCardExpansion(index: number) {
    if (this.expandedCard === index) {
      this.expandedCard = null;
    } else {
      this.expandedCard = index;
    }
  }

  private infiniteHandler($state: any): void {
    const nextItems = this.visibleEvents.length + this.itemsPerLoad;
    const newEvents = this.events.slice(this.visibleEvents.length, nextItems);
    this.visibleEvents.push(...newEvents);

    if (this.visibleEvents.length >= this.events.length) {
      $state.complete();
    } else {
      $state.loaded();
    }
  }

  private getCustomHolidayEvents(endDate: string) {
    const customHolidayEvents: CalendarEvent[] = [];
    this.scheduledHolidayMetadatas.forEach(scheduledHolidayMetadata => {
      const scheduledHolidayRruleSet = scheduledHolidayMetadata.rruleSet;
      const holidayStartDateTimeList = occurrencesForTargetMonth(
        scheduledHolidayRruleSet,
        endDate
      );
      if (holidayStartDateTimeList) {
        holidayStartDateTimeList.forEach(holidayStartDateTime => {
          const event = {
            eventType: EventType.CustomHoliday,
            name: scheduledHolidayMetadata.title,
            title: scheduledHolidayMetadata.title,
            start: newPortalDate(holidayStartDateTime, 'YYYY-MM-DD').toString(),
            rruleSet: scheduledHolidayRruleSet,
            eventId: scheduledHolidayMetadata.id,
            labels: scheduledHolidayMetadata.labels,
          };
          customHolidayEvents.push(event);
        });
      }
    });
    this.allHolidayEvents.push(...customHolidayEvents);
  }

  private getPublicHolidayEvents() {
    const publicHolidayEvents: CalendarEvent[] = [];
    this.publicHolidays.forEach(publicHoliday => {
      const event = {
        eventType: EventType.PublicHoliday,
        name: publicHoliday.title,
        title: publicHoliday.title,
        start: publicHoliday.startDate,
        labels: [publicHoliday.label],
      };
      publicHolidayEvents.push(event);
    });
    this.allHolidayEvents.push(...publicHolidayEvents);
  }

  private async getNormalEvents(startDate: PortalDate, endDate: PortalDate) {
    const normalEvents: CalendarEvent[] = [];
    this.scheduledEventMetadatas.forEach(scheduledEventMetadata => {
      const scheduledEventRruleSet = scheduledEventMetadata.rruleSet;
      const scheduledEventStartDateTimeList = occurrencesForTargetMonth(
        scheduledEventRruleSet,
        endDate.toString()
      );
      if (scheduledEventStartDateTimeList) {
        scheduledEventStartDateTimeList.forEach(scheduledEventStartDateTime => {
          const startYYYYMMDDHHmm = newPortalDate(
            scheduledEventStartDateTime,
            'YYYY-MM-DD HH:mm:ss'
          ).toString();
          const event = this.generateEventWithoutEventHistory(
            startYYYYMMDDHHmm,
            scheduledEventMetadata,
            scheduledEventRruleSet
          );
          normalEvents.push(event);
        });
      }
    });
    const adjustedNormalEvents = normalEvents.map(event =>
      makeAdjustments(event, this.allHolidayEvents)
    );
    this.moreThan1000ConsecutiveHolidayContainingEvents = adjustedNormalEvents.filter(
      event =>
        event && Object.keys(event).includes(FAILED_TO_ADJUST_DATE_EVENT_ID_KEY)
    );
    const nonNullAndNotFailedAdjustedNormalEvents = adjustedNormalEvents.filter(
      event =>
        event &&
        !Object.keys(event).includes(FAILED_TO_ADJUST_DATE_EVENT_ID_KEY)
    ) as CalendarEvent[];

    const filteredDuplicateNormalEvents = filterDuplicatedEvents(
      nonNullAndNotFailedAdjustedNormalEvents
    ) as CalendarEvent[];

    const eventsBasedOnScheduledEventHistory = this.getEventsBasedOnScheduledEventHistory();
    const normalEventsWithEventsBasedOnScheduledEventHistory = this.combineFilteredDuplicateNormalEventsWithEventsBasedOnScheduledEventHistory(
      filteredDuplicateNormalEvents,
      eventsBasedOnScheduledEventHistory
    );

    const thisMonthEvents = getSpecifiedPeriodItems(
      normalEventsWithEventsBasedOnScheduledEventHistory,
      startDate,
      endDate
    );

    this.events.push(...this.sortEventByStartDateTime(thisMonthEvents));
  }

  private combineFilteredDuplicateNormalEventsWithEventsBasedOnScheduledEventHistory(
    filteredDuplicateNormalEvents: CalendarEvent[],
    eventsBasedOnScheduledEventHistory: CalendarEvent[]
  ): CalendarEvent[] {
    const normalEventsWithEventsBasedOnEventHistory = R.concat(
      eventsBasedOnScheduledEventHistory,
      filteredDuplicateNormalEvents
    );
    return filterDuplicatedEvents(normalEventsWithEventsBasedOnEventHistory);
  }

  private getEventsBasedOnScheduledEventHistory(): any {
    return this.scheduledEventHistoriesBasedOnBetweenDates.map(
      scheduledEventHistoryForTargetMonth => {
        const scheduledEventMetadata = this.scheduledEventMetadatas.find(
          item =>
            scheduledEventHistoryForTargetMonth.scheduledEventMetadataId ===
            item.id
        );
        const status = scheduledEventHistoryForTargetMonth.jobExecutionStatus;
        const title = scheduledEventHistoryForTargetMonth.title;
        const executedBy = scheduledEventHistoryForTargetMonth.executedBy;
        const updatedAt = scheduledEventHistoryForTargetMonth.updatedAt;
        const taskHistories: TaskHistory[] | undefined = R.path(
          ['taskHistories', 'items'],
          scheduledEventHistoryForTargetMonth
        );
        const start = newPortalDate(
          scheduledEventHistoryForTargetMonth.eventStartDateTime,
          'YYYY-MM-DD HH:mm:ss'
        ).toString();
        if (!scheduledEventMetadata) {
          return this.generateEventWithoutScheduledEventMetadata(
            scheduledEventHistoryForTargetMonth,
            status,
            title,
            taskHistories,
            start
          );
        }
        return {
          eventType: EventType.NormalEvent,
          name: this.concatStartTimeWithTitle(start, title),
          title,
          start,
          rruleSet: scheduledEventMetadata.rruleSet,
          eventId: scheduledEventMetadata.id,
          jobId: scheduledEventMetadata.job
            ? scheduledEventMetadata.job.id
            : '',
          jobTitle: scheduledEventMetadata.job
            ? scheduledEventMetadata.job.title
            : '',
          hasOutputFile: scheduledEventMetadata.job
            ? scheduledEventMetadata.job.hasOutputFile
            : false,
          icon: eventIcon(status),
          iconColor: eventIconColor(status),
          labels: scheduledEventMetadata.customHolidayLabels,
          holidayExecutionType: scheduledEventMetadata.holidayExecutionType,
          triggerOnHolidays: scheduledEventMetadata.triggerOnHolidays,
          eventHistoryId: scheduledEventHistoryForTargetMonth.id,
          status,
          taskHistories,
          isEventWithoutScheduledEventMetadata: false,
          executedBy,
          updatedAt,
          eventTriggerType: scheduledEventMetadata.eventTriggerType,
        };
      }
    );
  }

  private generateEventWithoutScheduledEventMetadata(
    scheduledEventHistoryForTargetMonth: ScheduledEventHistoryForFront,
    status: JobExecutionStatus,
    title: string,
    taskHistories: TaskHistory[] | undefined,
    start: string
  ): CalendarEvent {
    return {
      eventType: EventType.NormalEvent,
      name: this.concatStartTimeWithTitle(start, title),
      title,
      start,
      eventId: scheduledEventHistoryForTargetMonth.scheduledEventMetadataId,
      jobId: scheduledEventHistoryForTargetMonth.job
        ? scheduledEventHistoryForTargetMonth.job.id
        : '',
      jobTitle: scheduledEventHistoryForTargetMonth.job
        ? scheduledEventHistoryForTargetMonth.job.title
        : '',
      hasOutputFile: scheduledEventHistoryForTargetMonth.job
        ? scheduledEventHistoryForTargetMonth.job.hasOutputFile
        : false,
      icon: eventIcon(status),
      iconColor: eventIconColor(status),
      eventHistoryId: scheduledEventHistoryForTargetMonth.id,
      status,
      taskHistories,
      isEventWithoutScheduledEventMetadata: true,
    };
  }

  private generateEventWithoutEventHistory(
    startYYYYMMDDHHmm: string,
    scheduledEventMetadata: ScheduledEventMetadataWithDetailForFront,
    rruleSet: string
  ): CalendarEvent {
    const status = JobExecutionStatus.NotTriggered;
    const title = scheduledEventMetadata.title;
    const eventTriggerType = scheduledEventMetadata.eventTriggerType;
    return {
      eventType: EventType.NormalEvent,
      name: this.concatStartTimeWithTitle(startYYYYMMDDHHmm, title),
      title,
      start: startYYYYMMDDHHmm,
      rruleSet,
      eventId: scheduledEventMetadata.id,
      status,
      jobId: scheduledEventMetadata.job ? scheduledEventMetadata.job.id : '',
      jobTitle: scheduledEventMetadata.job
        ? scheduledEventMetadata.job.title
        : '',
      hasOutputFile: scheduledEventMetadata.job
        ? scheduledEventMetadata.job.hasOutputFile
        : false,
      icon: eventIcon(status),
      iconColor: eventIconColor(status),
      labels: scheduledEventMetadata.customHolidayLabels,
      holidayExecutionType: scheduledEventMetadata.holidayExecutionType,
      triggerOnHolidays: scheduledEventMetadata.triggerOnHolidays,
      isEventWithoutScheduledEventMetadata: false,
      eventTriggerType,
    };
  }

  private concatStartTimeWithTitle(start: string, name: string): string {
    return `${newPortalDate(dayjs(start), 'HH:mm').toString()} ${name}`;
  }

  private includesCaseInsensitive = (searchString?: string) => (
    value?: string
  ) => {
    return searchString && value
      ? R.toLower(value).includes(R.toLower(searchString))
      : false;
  };

  private filteredBySearch = async (
    searchInput: EventSearchInput,
    events: CalendarEvent[]
  ): Promise<CalendarEvent[]> => {
    const filterCondition = R.where({
      name: searchInput.eventTitle
        ? this.includesCaseInsensitive(searchInput.eventTitle)
        : R.T,
      status: searchInput.jobExecutionStatus
        ? R.equals(searchInput.jobExecutionStatus)
        : R.T,
      eventTriggerType: searchInput.eventTriggerType
        ? R.equals(searchInput.eventTriggerType)
        : R.T,
      executedBy: searchInput.executedBy
        ? this.includesCaseInsensitive(searchInput.executedBy)
        : R.T,
      jobId: searchInput.job ? R.equals(searchInput.job.id) : R.T,
    });
    return R.filter(filterCondition, events);
  };

  private sortEventByStartDateTime(events: CalendarEvent[]): CalendarEvent[] {
    return events.sort((x, y) => {
      return dayjs(x.start).valueOf() - dayjs(y.start).valueOf();
    });
  }

  private get getResultCountText(): string {
    return `${this.$t('jobScheduler.eventCalendar.searchResult')}
      ${this.events.length} ${this.$t('jobScheduler.eventCalendar.item')}`;
  }

  private get firstDayOfMonth() {
    return dayjs()
      .startOf('month')
      .format('YYYY-MM-DD');
  }

  private get lastDayOfMonth() {
    return dayjs()
      .endOf('month')
      .format('YYYY-MM-DD');
  }

  private get locale(): string {
    const locale = i18n.locale as Language;
    switch (locale) {
      case Language.ja:
        return 'ja-jp';
      case Language.en:
        return 'en-us';
      default: {
        const inspector: never = locale;
        return 'ja-jp';
      }
    }
  }

  private get items(): { [key: string]: any } {
    return {
      event: {
        text: this.$t('jobScheduler.events.event'),
        value: Option.Event,
      },
      holiday: {
        text: this.$t('jobScheduler.holidays.holiday'),
        value: Option.Holiday,
      },
    };
  }

  private get jobExecutionStatusOptions() {
    return [
      {
        text: i18n.tc('jobScheduler.eventCalendar.notSpecified'),
        value: null,
        icon: null,
        color: null,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.succeeded'),
        value: JobExecutionStatus.Succeeded,
        icon: ICON.SUCCEEDED.NAME,
        color: ICON.SUCCEEDED.COLOR,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.failed'),
        value: JobExecutionStatus.Failed,
        icon: ICON.FAILED.NAME,
        color: ICON.FAILED.COLOR,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.running'),
        value: JobExecutionStatus.Running,
        icon: ICON.RUNNING.NAME,
        color: ICON.RUNNING.COLOR,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.notTriggered'),
        value: JobExecutionStatus.NotTriggered,
        icon: ICON.NOT_TRIGGERED.NAME,
        color: ICON.NOT_TRIGGERED.COLOR,
      },
    ];
  }

  private get executionTypeOptions() {
    return [
      { text: i18n.tc('jobScheduler.eventCalendar.notSpecified'), value: null },
      {
        text: i18n.tc('jobScheduler.eventCalendar.immediate'),
        value: EventTriggerType.Immediate,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.scheduled'),
        value: EventTriggerType.Scheduled,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.throughAPI'),
        value: EventTriggerType.ThroughAPI,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.throughFsync'),
        value: EventTriggerType.ThroughFsync,
      },
      {
        text: i18n.tc('jobScheduler.eventCalendar.retry'),
        value: EventTriggerType.Retry,
      },
    ];
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get dateValidationMessage(): string {
    return this.isEndDateAfterStartDate
      ? ''
      : i18n.tc('jobScheduler.eventCalendar.invalidDate');
  }

  private get isEndDateAfterStartDate(): boolean {
    if (!this.searchInput.startTime || !this.searchInput.endTime) {
      return false;
    }
    return this.endDateTimeFromInput > this.startDateTimeFromInput;
  }

  private get startDateTimeFromInput(): PortalDate {
    const startDateTime = `${this.searchInput.startDate} ${this.searchInput.startTime}`;
    return newPortalDate(startDateTime, 'YYYY-MM-DD HH:mm');
  }

  private get endDateTimeFromInput(): PortalDate {
    const endDateTime = `${this.searchInput.endDate} ${this.searchInput.endTime}:59`;
    return newPortalDate(endDateTime, 'YYYY-MM-DD HH:mm:ss');
  }
}
